/**
 * PrintLayout — A6-landscape print component.
 * sp- class names + print.css (no media queries).
 * Matches the on-screen sticker at the ≤1700px breakpoint.
 */
import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import logo from '../../images/logo_latest.png';
import coffeeType4 from '../../images/coffee_types/coffee_type_4.png';
import coffeeType3 from '../../images/coffee_types/coffee_type_3.png';
import coffeeType2 from '../../images/coffee_types/coffee_type_2.png';
import coffeeType6 from '../../images/coffee_types/coffee_type_6.png';
import coffeeType5 from '../../images/coffee_types/coffee_type_5.png';
import coffeeType1 from '../../images/coffee_types/coffee_type_1.png';
import HE from '../../languages/he';
import leftTopNoteBg from '../../images/taste_notes/left_top.png';
import leftTopNoteBgActive from '../../images/taste_notes/left_top_active.png';
import leftTopNoteIcon from '../../images/taste_notes/left_top_icon.svg';
import leftTopNoteIconActive from '../../images/taste_notes/left_top_icon_active.svg';
import rightTopNoteBg from '../../images/taste_notes/right_top.png';
import rightTopNoteBgActive from '../../images/taste_notes/right_top_active.png';
import rightTopNoteIcon from '../../images/taste_notes/right_top_icon.svg';
import rightTopNoteIconActive from '../../images/taste_notes/right_top_icon_active.svg';
import leftBottomNoteBg from '../../images/taste_notes/left_bottom.png';
import leftBottomNoteBgActive from '../../images/taste_notes/left_bottom_active.png';
import leftBottomNoteIcon from '../../images/taste_notes/left_bottom_icon.svg';
import leftBottomNoteIconActive from '../../images/taste_notes/left_bottom_icon_active.svg';
import rightBottomNoteBg from '../../images/taste_notes/right_bottom.png';
import rightBottomNoteBgActive from '../../images/taste_notes/right_bottom_active.png';
import rightBottomNoteIcon from '../../images/taste_notes/right_bottom_icon.svg';
import rightBottomNoteIconActive from '../../images/taste_notes/right_bottom_icon_active.svg';
import roastedAlmondIcon from '../../images/taste_notes/flavors/agro-icon-brown-16.svg';
import sugarCaneIcon from '../../images/taste_notes/flavors/flavor_2.svg';
import herbsIcon from '../../images/taste_notes/flavors/agro-icon-brown-7.svg';
import cloveIcon from '../../images/taste_notes/flavors/agro-icon-brown-8.svg';
import spicesIcon from '../../images/taste_notes/flavors/flavor_4.svg';
import cinnamonIcon from '../../images/taste_notes/flavors/flavor_5.svg';
import vanillaIcon from '../../images/taste_notes/flavors/agro-icon-brown-25.svg';
import brownSugarIcon from '../../images/taste_notes/flavors/agro-icon-brown-14.svg';
import caramelIcon from '../../images/taste_notes/flavors/agro-icon-brown-14.svg';
import hibiscusIcon from '../../images/taste_notes/flavors/agro-icon-brown-17.svg';
import honeyIcon from '../../images/taste_notes/flavors/agro-icon-brown-1.svg';
import mapleSyrupIcon from '../../images/taste_notes/flavors/agro-icon-brown-3.svg';
import appleIcon from '../../images/taste_notes/flavors/agro-icon-brown-24.svg';
import mangoIcon from '../../images/taste_notes/flavors/agro-icon-brown-26.svg';
import orangeIcon from '../../images/taste_notes/flavors/agro-icon-brown-10.svg';
import brownButterIcon from '../../images/taste_notes/flavors/agro-icon-brown-21.svg';
import peanutsIcon from '../../images/taste_notes/flavors/flavor_6.svg';
import hazelnutIcon from '../../images/taste_notes/flavors/flavor_7.svg';
import chocolateIcon from '../../images/taste_notes/flavors/flavor_9.svg';
import almondIcon from '../../images/taste_notes/flavors/flavor_1.svg';
import milkChocolateIcon from '../../images/taste_notes/flavors/agro-icon-brown-4.svg';
import cocoaIcon from '../../images/taste_notes/flavors/flavor_8.svg';
import whiteChocolateIcon from '../../images/taste_notes/flavors/agro-icon-brown-19.svg';
import jasmineFlowerIcon from '../../images/taste_notes/flavors/agro-icon-brown-17.svg';
import walnutIcon from '../../images/taste_notes/flavors/walnut-icon.svg';
import lemonGrassIcon from '../../images/taste_notes/flavors/lemon-grass-icon-new.svg';
import blueberryIcon from '../../images/taste_notes/flavors/blueberry-icon.svg';
import grapefruitIcon from '../../images/taste_notes/flavors/grapefruit-icon.svg';
import bakedPearIcon from '../../images/taste_notes/flavors/agro-icon-brown-12.svg';
import citrusFruitsIcon from '../../images/taste_notes/flavors/citrus-icon-new.svg';
import hotelIcon from '../../images/taste_notes/flavors/hotel-icon.svg';
import halvahIcon from '../../images/taste_notes/flavors/halvah-icon.svg';
import toffeeIcon from '../../images/taste_notes/flavors/toffee-icon.svg';
import licoriceIcon from '../../images/taste_notes/flavors/licorice-icon.png';
import biscuitIcon from '../../images/taste_notes/flavors/biscuit-icon.png';
import dateHoneyIcon from '../../images/taste_notes/flavors/date_honey_icon.svg';
import tropicalFruitsIcon from '../../images/taste_notes/flavors/tropical-fruits-icon_new.png';
import agroIcon from '../../images/flower.png';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import axios from 'axios';
import SpiderChartPrint from '../../components/charts/radarPrint';
import './print.css';

const coffeeTypesMy = [
  { icon: coffeeType4 }, { icon: coffeeType3 }, { icon: coffeeType2 },
  { icon: coffeeType6 }, { icon: coffeeType5 }, { icon: coffeeType1 },
];

// Flavor icon arrays — same order as original sticker
const flavors0 = [
  { icon: roastedAlmondIcon }, { icon: sugarCaneIcon }, { icon: herbsIcon },
  { icon: cloveIcon }, { icon: spicesIcon }, { icon: cinnamonIcon },
  { icon: lemonGrassIcon }, { icon: licoriceIcon },
];
const flavors1 = [
  { icon: herbsIcon }, { icon: vanillaIcon }, { icon: brownSugarIcon },
  { icon: hibiscusIcon }, { icon: caramelIcon }, { icon: honeyIcon },
  { icon: jasmineFlowerIcon }, { icon: dateHoneyIcon }, { icon: mapleSyrupIcon },
  { icon: halvahIcon }, { icon: toffeeIcon }, { icon: biscuitIcon },
];
const flavors2 = [
  { icon: appleIcon }, { icon: mangoIcon }, { icon: lemonGrassIcon },
  { icon: blueberryIcon }, { icon: orangeIcon }, { icon: grapefruitIcon },
  { icon: bakedPearIcon }, { icon: tropicalFruitsIcon }, { icon: citrusFruitsIcon },
  { icon: hotelIcon },
];
const flavors3 = [
  { icon: brownButterIcon }, { icon: peanutsIcon }, { icon: hazelnutIcon },
  { icon: chocolateIcon }, { icon: almondIcon }, { icon: milkChocolateIcon },
  { icon: cocoaIcon }, { icon: whiteChocolateIcon }, { icon: walnutIcon },
];

// tasteNote index → { icons array, language notes index }
// 0=fruity&citrus, 1=chocolaty&nuts, 2=spices&roasted, 3=sweet&floral
const NOTE_BY_IDX = [
  { icons: flavors2, langIdx: 2 },
  { icons: flavors3, langIdx: 3 },
  { icons: flavors0, langIdx: 0 },
  { icons: flavors1, langIdx: 1 },
];
// Dynamic blend-note keys and their positions (right panel)
const DYNAMIC_NOTES = [
  { key: 'spices and roasted', posClass: 'sp-pos-tl', icons: flavors0, langIdx: 0 },
  { key: 'sweet and floral',   posClass: 'sp-pos-tr', icons: flavors1, langIdx: 1 },
  { key: 'fruity and citrus',  posClass: 'sp-pos-bl', icons: flavors2, langIdx: 2 },
  { key: 'chocolaty and nuts', posClass: 'sp-pos-br', icons: flavors3, langIdx: 3 },
];

// Arc segment — mirrors .notes-item > label > .label-value structure from StickerComponentPrint
// posClass matches the sticker's .label-value.top-right / .bottom-left / .bottom-right classes
function ArcSegment({ posClass, bg, bgActive, icon, iconActive, title, isActive }) {
  return (
    <div className={`sp-arc-pad${isActive ? ' sp-active' : ''}`}>
      <div className={`sp-arc-inner${posClass ? ' ' + posClass : ''}`}>
        <div className="sp-arc-bg">
          <img src={isActive ? bgActive : bg} alt="" />
        </div>
        <div className="sp-arc-icon">
          <img src={isActive ? iconActive : icon} alt="" />
        </div>
        <span className="sp-arc-title">{title}</span>
      </div>
    </div>
  );
}

// Notes circle with 4 arcs + floating panels
function NotesCircle({ arcData, floatPanels, isDynamic }) {
  return (
    <div className="sp-notes-wrap">
      <div className="sp-notes-circle">
        <div className="sp-notes-items">
          {arcData.map((arc, i) => (
            <ArcSegment key={i} {...arc} />
          ))}
        </div>
      </div>
      <div className={`sp-float${isDynamic ? ' sp-dynamic' : ' sp-nondynamic'}`}>
        {floatPanels}
      </div>
    </div>
  );
}

const PrintLayout = React.forwardRef(({ coffeeID, lang }, ref) => {
  const lf = HE;

  const [blendName, setBlendName] = useState(lf.coffeeSticker.defaultBlendName);
  const [matchPct, setMatchPct]   = useState(85);
  const [targetProfile, setTargetProfile] = useState({
    sweetness: 2, acidity: 3, bitterness: 2, body: 3,
    tasteNotes: [2, 0], drinkingType: 2,
  });
  const [blendProfile, setBlendProfile] = useState({
    blendProfile: { sweetness: 4, acidity: 5, bitterness: 1, body: 2 },
  });
  const [currentTasteNotes, setCurrentTasteNotes] = useState({});
  const [roastLevel, setRoastLevel]               = useState(2);
  const [coffeeBlendsValue, setCoffeeBlendsValue] = useState({
    brazil: 0, colombia: 90, ethiopia: 0, honduras: 0, papua: 10, robusta: 0,
  });

  useEffect(() => {
    axios.get('https://mycoffeeid.com/api/get-blend-data/' + coffeeID)
      .then(({ data: r }) => {
        if (!r.blendName) return;
        setBlendName(r.blendName);
        setMatchPct(r.match);
        setTargetProfile({
          sweetness:    r.clientDetails.preferences.sweetness,
          acidity:      r.clientDetails.preferences.acidity,
          bitterness:   r.clientDetails.preferences.bitterness,
          body:         r.clientDetails.preferences.body,
          tasteNotes:   r.clientDetails.tasteNotes,
          drinkingType: r.clientDetails.type,
        });
        setBlendProfile({
          blendProfile: {
            sweetness:  r.blendPreferences.sweetness,
            acidity:    r.blendPreferences.acidity,
            bitterness: r.blendPreferences.bitterness,
            body:       r.blendPreferences.body,
          },
        });
        setCurrentTasteNotes(r.blendTasteNotes || {});
        setRoastLevel(r.roastingLevel);
        setCoffeeBlendsValue(r.blendTypes);
      })
      .catch(console.error);
  }, [coffeeID]);

  const fillClass = matchPct >= 85 ? 'sp-match-fill'
    : matchPct >= 70 ? 'sp-match-fill sp-med'
    : 'sp-match-fill sp-low';

  const notes = lf.thirdStep.notes;
  const tn    = currentTasteNotes || {};

  // Left panel arc active states — same logic as original sticker checkboxes
  // posClass mirrors .label-value.top-right / .bottom-left / .bottom-right on the original sticker
  const leftArcData = [
    {
      posClass: '',
      bg: leftTopNoteBg,    bgActive: leftTopNoteBgActive,
      icon: leftTopNoteIcon,    iconActive: leftTopNoteIconActive,
      title: notes[0].title, isActive: targetProfile.tasteNotes.includes(2),
    },
    {
      posClass: 'top-right',
      bg: rightTopNoteBg,   bgActive: rightTopNoteBgActive,
      icon: rightTopNoteIcon,   iconActive: rightTopNoteIconActive,
      title: notes[1].title, isActive: targetProfile.tasteNotes.includes(3),
    },
    {
      posClass: 'bottom-left',
      bg: leftBottomNoteBg, bgActive: leftBottomNoteBgActive,
      icon: leftBottomNoteIcon, iconActive: leftBottomNoteIconActive,
      title: notes[2].title, isActive: targetProfile.tasteNotes.includes(0),
    },
    {
      posClass: 'bottom-right',
      bg: rightBottomNoteBg,bgActive: rightBottomNoteBgActive,
      icon: rightBottomNoteIcon,iconActive: rightBottomNoteIconActive,
      title: notes[3].title, isActive: targetProfile.tasteNotes.includes(1),
    },
  ];

  // Right panel arc active states
  const rightArcData = [
    {
      posClass: '',
      bg: leftTopNoteBg,    bgActive: leftTopNoteBgActive,
      icon: leftTopNoteIcon,    iconActive: leftTopNoteIconActive,
      title: notes[0].title, isActive: !!tn['spices and roasted'],
    },
    {
      posClass: 'top-right',
      bg: rightTopNoteBg,   bgActive: rightTopNoteBgActive,
      icon: rightTopNoteIcon,   iconActive: rightTopNoteIconActive,
      title: notes[1].title, isActive: !!tn['sweet and floral'],
    },
    {
      posClass: 'bottom-left',
      bg: leftBottomNoteBg, bgActive: leftBottomNoteBgActive,
      icon: leftBottomNoteIcon, iconActive: leftBottomNoteIconActive,
      title: notes[2].title, isActive: !!tn['fruity and citrus'],
    },
    {
      posClass: 'bottom-right',
      bg: rightBottomNoteBg,bgActive: rightBottomNoteBgActive,
      icon: rightBottomNoteIcon,iconActive: rightBottomNoteIconActive,
      title: notes[3].title, isActive: !!tn['chocolaty and nuts'],
    },
  ];

  // Left panel float panels (non-dynamic) — matches original float-flavors (no corner classes;
  // CSS handles: first panel left:0, last-child right:0, both at top:0)
  const leftFloatPanels = [0, 1, 2, 3].map((noteIdx) => {
    if (!targetProfile.tasteNotes.includes(noteIdx)) return null;
    const { icons, langIdx } = NOTE_BY_IDX[noteIdx];
    const familyNotes = notes[langIdx].tastes;
    return (
      <div className="sp-panel" key={noteIdx}>
        <div className="sp-panel-title">{notes[langIdx].title}</div>
        {icons.slice(0, 5).map((el, i) => (
          <div className="sp-panel-row" key={i}>
            <span className="sp-panel-icon"><img src={el.icon} alt="" /></span>
            <span className="sp-panel-name">{familyNotes[i]}</span>
          </div>
        ))}
      </div>
    );
  });

  // Right panel float panels (dynamic) — same logic as original float-flavors.dynamic
  const rightFloatPanels = DYNAMIC_NOTES.map(({ key, posClass, icons, langIdx }) => {
    const noteData = tn[key];
    if (!noteData || noteData.length === 0) {
      return (
        <div className={`sp-panel sp-panel-empty ${posClass}`} key={key}>
          <img src={agroIcon} alt="" />
        </div>
      );
    }
    const familyNotes = notes[langIdx].tastes;
    return (
      <div className={`sp-panel ${posClass}`} key={key}>
        <div className="sp-panel-title">{notes[langIdx].title}</div>
        {noteData.map((name, i) => {
          const idx = familyNotes.indexOf(name);
          const iconUrl = idx !== -1 ? icons[idx] : icons[0];
          return (
            <div className="sp-panel-row" key={i}>
              <span className="sp-panel-icon"><img src={iconUrl.icon} alt="" /></span>
              <span className="sp-panel-name">{name}</span>
            </div>
          );
        })}
      </div>
    );
  });

  return (
    <div className="sp-print-page" ref={ref}>
      <div className="sp-wrapper">

        {/* QR — absolute top-left, same as .sticker-qr-desktop */}
        <div className="sp-qr">
          <QRCodeSVG
            value={window.location.origin + '/' + lang + '/' + coffeeID}
            size={80} bgColor="transparent" fgColor="#E6D0B1" level="H"
          />
          <span className="sp-qr-label">{lf.coffeeSticker.qrScanLabel}</span>
        </div>

        {/* Logo — matches .page-header */}
        <div className="sp-header">
          <img src={logo} alt="AgroCafe" />
        </div>

        <div className="sp-main">

          {/* ══════════ LEFT PANEL (.blend-wrapper_left.editor-left) ══════════ */}
          <div className="sp-left">

            {/* Coffee type — .coffee-type */}
            <div className="sp-coffee-type">
              {targetProfile.drinkingType !== '' && (
                <div className="sp-coffee-icon-box">
                  <img src={coffeeTypesMy[targetProfile.drinkingType].icon} alt="" />
                  <div className="sp-coffee-icon-name">
                    {lf.firstStep.coffeeTypes[targetProfile.drinkingType]}
                  </div>
                </div>
              )}
              <div className="sp-coffee-info">
                <div className="sp-coffee-info-title">{lf.sixthStep.title}</div>
                <div className="sp-coffee-info-sub">{lf.sixthStep.subtitle}</div>
              </div>
            </div>

            {/* Flavors — .flavors */}
            <div className="sp-flavors">
              <div className="sp-section-header">
                <div className="sp-sec-title">{lf.sixthStep.flavorsTitle}</div>
                <hr className="sp-sec-hr" />
              </div>
              <div className="sp-flavors-row">
                <div className="sp-flavors-vals">
                  <div className="sp-flavor-item">
                    <span className="sp-fval">{targetProfile.acidity}/5</span>
                    {lf.secondStep.preferences[0].title}
                  </div>
                  <div className="sp-flavor-item">
                    <span className="sp-fval">{targetProfile.sweetness}/5</span>
                    {lf.secondStep.preferences[1].title}
                  </div>
                  <div className="sp-flavor-item">
                    <span className="sp-fval">{targetProfile.bitterness}/5</span>
                    {lf.secondStep.preferences[2].title}
                  </div>
                  <div className="sp-flavor-item">
                    <span className="sp-fval">{targetProfile.body}/5</span>
                    {lf.secondStep.preferences[3].title}
                  </div>
                </div>
                <div className="sp-radar-wrap">
                  <SpiderChartPrint chartData={targetProfile} lang="he" />
                </div>
              </div>
            </div>

            {/* Taste notes — .tastes */}
            <div className="sp-tastes">
              <div className="sp-section-header">
                <div className="sp-sec-title">{lf.sixthStep.tasteNoteTitle}</div>
                <hr className="sp-sec-hr" />
              </div>
              <NotesCircle
                arcData={leftArcData}
                floatPanels={leftFloatPanels}
                isDynamic={false}
                notes={notes}
              />
            </div>
          </div>

          {/* ══════════ RIGHT PANEL (.blend-wrapper_right) ══════════ */}
          <div className="sp-right">

            {/* Blend name — .sticker-title */}
            <div className="sp-blend-name">{blendName}</div>

            {/* Match bar — .editor-top */}
            <div className="sp-match-bar">
              <span className="sp-match-pct">{matchPct}%</span>
              <div className="sp-match-title">{lf.editor.matchPercentageTitle}:</div>
              <div className="sp-match-track">
                <div className={fillClass} style={{ width: matchPct + '%' }} />
              </div>
            </div>

            {/* Editor blocks row 1 — coffee origins + taste profile chart */}
            <div className="sp-blocks">
              <div className="sp-block">
                <div className="sp-block-in">
                  <div className="sp-block-title">{lf.editor.selectCoffeeBlend}</div>
                  <div className="sp-coffee-items">
                    {Object.keys(coffeeBlendsValue).map((key, i) => {
                      const pct = coffeeBlendsValue[key];
                      if (!pct) return null;
                      return (
                        <div className="sp-coffee-item" key={i}>
                          <div className="sp-coffee-label">{lf.editor.coffeeBlends[key]}</div>
                          <div className="sp-coffee-item-val">{pct}%</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="sp-block sp-wide">
                <div className="sp-block-in">
                  <div className="sp-block-title">{lf.editor.tasteProfile}</div>
                  <div className="sp-taste-profile">
                    <SpiderChartPrint chartData={targetProfile} multiple={blendProfile} lang="he" />
                  </div>
                </div>
              </div>
            </div>

            {/* Editor blocks row 2 — roast slider + blend taste notes */}
            <div className="sp-blocks">
              <div className="sp-block">
                <div className="sp-block-in">
                  <div className="sp-block-title">{lf.editor.selectRoastLevel}</div>
                  <div className="sp-roast-wrap">
                    <RangeSlider
                      className={'roasting_level level-' + roastLevel}
                      min={1} max={3} step={0.1}
                      thumbsDisabled={[true, false]}
                      rangeSlideDisabled={false}
                      orientation="vertical"
                      value={[1, roastLevel === 1 ? 1.2 : roastLevel]}
                      onInput={() => {}}
                    />
                  </div>
                </div>
              </div>
              <div className="sp-block sp-wide">
                <div className="sp-block-in">
                  <div className="sp-block-title">{lf.editor.tastesNotes}</div>
                  <NotesCircle
                    arcData={rightArcData}
                    floatPanels={rightFloatPanels}
                    isDynamic={true}
                    notes={notes}
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
});

export default PrintLayout;
